import { render, staticRenderFns } from "./ReportIrst.vue?vue&type=template&id=44cf8470&"
import script from "./ReportIrst.vue?vue&type=script&lang=js&"
export * from "./ReportIrst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports